module.exports = __webpack_public_path__ + "static/media/fasad9.a222514e.jpeg";